/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SendingInputs */

const he_common_sending = /** @type {(inputs: Common_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולח...`)
};

const en_common_sending = /** @type {(inputs: Common_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Common_SendingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_sending = /** @type {((inputs?: Common_SendingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SendingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_sending(inputs)
	return en_common_sending(inputs)
});